import basePath from "base_path";
import ActionTypes, {ProjectActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId, ProjectIssueOverrideTag} from "common/types/project";

export type IssueOverrideTagReorderAction = {
  type: ProjectActionTypes["PROJECT_REORDER_ISSUE_OVERRIDE_TAG"]["SUCCESS"];
  payload: ProjectIssueOverrideTag[];
};

export default function projectReorderIssueOverrideTag(requestor) {
  return createReduxPromiseAction(
    ActionTypes.PROJECT_REORDER_ISSUE_OVERRIDE_TAG,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      tagId: string,
      position: number,
    ) => {
      return requestor
        .put(
          `${basePath}/organisation/${organisationId}/project/${projectId}/issue_override_tag/${tagId}/reorder`,
          {position},
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
